import React, { useState, useEffect, useRef, useCallback } from "react";
import { useForm, Controller } from "react-hook-form";
import TableWrapper from "../../../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";
import { Tooltip, Autocomplete, TextField, Checkbox, CircularProgress, FormControlLabel } from "@mui/material";
import { MdModeEditOutline } from "react-icons/md";
import { callAPI } from "../../../../../axios";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicModal from "../../../../core/BaseComponents/Modal";
import deleteImg from '../../../../../assets/images/delete.png';
import { IoMdWarning } from "react-icons/io";
import { RiHotelBedFill } from "react-icons/ri";
import Custom_Paingation from "../../../../core/BaseComponents/Custom_Paingation";
import { ScrollToTop, getChainIdLS, getUserRoleCodeFromStorage, isValidRole } from "../../../../../utils/utils";
import { useSelector } from "react-redux";
import ConfigureNewRoomExcel from "./ConfigureNewRoomExcel";
import { faFileDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { debounce } from 'lodash';

function ConfigurationNewRoom() {
  const [roomList, setRoomList] = useState({});
  const [roomTypesMaster, setRoomTypesMaster] = useState([]);
  const [cdsnsMaster, setCdsnsMaster] = useState([]);
  const [confirmDeleteRoom, setConfirmDeleteRoom] = useState("");
  const [confirmValidate, setConfirmValidate] = useState(false);
  const [deleteRoomPopUp, setDeleteRoomPopUp] = useState(false);
  const [editRoom, setEditRoom] = useState(false);
  const [editRoomUpdate, setEditRoomUpdate] = useState(false);
  const [createRoomSuccessMsg, setCreateRoomSuccessMsg] = useState('');
  const [editRoomSid, setEditRoomSid] = useState("");
  const [globalSsidMessagePopup, setGlobalSsidMessagePopup] = useState(false)
  const [loader, setLoader] = useState(false);
  const recordsPerPage = 10;

  const [hideRoom, setHideRoom] = useState(false)
  const [showRoomNumbersConfirmPopup, setShowRoomNumbersConfirmPopup] = useState(false)
  const [pendingShowRoomValue, setPendingShowRoomValue] = useState(null)
  const [debouncedSearchText, setDebouncedSearchText] = useState('');
  const [searchText, setSearchText] = useState("");
  // const [searchTextValidation, setSearchTextValidation] = useState("");
  // let userRoleCode = getUserRoleCodeFromStorage();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    watch,
    setValue
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      globalSsid: false
    },
  });

  const { chainId } = useSelector((state) => state.chainIdReducer);

  let validPermissionClassName = isValidRole("ROOM_CONFIGURATION_MODIFY")
    ? ""
    : "btn-disable-permission";

  const [selectedPage, setSelectedPage] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(1);
  const [paginationError, setPaginationError] = useState("")
  const [inputPageValue, setInputPageValue] = useState(1)

  const onSubmit = (data) => {
    setLoader(true)
    if(watch("globalSsid")===true && globalSsidMessagePopup===false){
      setGlobalSsidMessagePopup(true)
      return
    }
    let method = "POST";
    let url = "/create/room";
    let payload = { ...data, cdsn: data?.cdsn?.map((item)=>item?.cdsn) };

    if (editRoomUpdate) {
      method = "PUT"
      url = `/update/room`
      payload = { ...data, cdsn: data?.cdsn?.map((item)=>item?.cdsn), id: editRoomSid?.id };
    }

    callAPI(url, method, payload, { chainId: getChainIdLS() })
      .then(function (response) {
        reset({
          roomNo: '',
          roomType: '',
          cdsn: [],
          ssid: '',
          globalSsid: false
        });
        callGetCdsn()
        setCreateRoomSuccessMsg(response?.message);
        roomListApi();
        setLoader(false)
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
        setLoader(false)
      });
  };

  const isRoomDeletedRef = useRef({
    isRoomDeletedModalData: null,
    userConformationModalData: null,
  });

  // const deleteRoomPopUpHandler = (row) => {
  //   setDeleteRoomPopUp(true);
  //   const newModalRefData = {
  //     isRoomDeletedModalData: {
  //       row
  //     },
  //     userConformationModalData: null,
  //   };
  //   isRoomDeletedRef.current = newModalRefData;
  // }

  const deleteRoomHandler = () => {
    setConfirmValidate(true);
    if (confirmDeleteRoom === "") {
      return
    }

    if (confirmDeleteRoom === `Delete Room No ${isRoomDeletedRef.current?.isRoomDeletedModalData.row.roomNo}`) {
      setConfirmValidate(false)
      const { row } = isRoomDeletedRef.current?.isRoomDeletedModalData;
      callAPI(`delete-room?roomId=${row?.id}`, "DELETE")
        .then((response) => {
          let successMessage = response.message
          const newModalRefData = {
            isRoomDeletedModalData: null,
            userConformationModalData: {
              successMessage
            },
          };
          isRoomDeletedRef.current = newModalRefData;
          callGetCdsn()
          roomListApi();
        })
        .catch((error) => {
          console.warn(error)
        });
    }
    reset({
      roomNo: '',
      roomType: '',
      cdsn: [],
      ssid: '',
      globalSsid: false
    });
  }

  // const renderActionIcon = (row) => {
  //   return (
  //     isValidRole("ROOM_CONFIGURATION_MODIFY")?<>
  //       <Tooltip title="Edit" arrow>
  //         <MdModeEditOutline
  //           className="edit-icon-enable"
  //           onClick={() => { setEditRoom(true); setEditRoomSid(row) }}
  //         />
  //       </Tooltip>
  //       <Tooltip title="Delete" className="cursor-pointer" arrow>
  //         <DeleteIcon
  //           className="delete-icon-enable"
  //           onClick={() => {
  //             deleteRoomPopUpHandler(row);
  //           }}
  //         />
  //       </Tooltip>
  //     </>:
  //     <>
  //     <Tooltip title="Don't have permission to edit" arrow>
  //       <span>
  //         <MdModeEditOutline className="edit-icon-disable" />
  //       </span>
  //     </Tooltip>
  //     <Tooltip title="Don't have permission to delete" arrow>
  //       <DeleteIcon className="delete-icon-disable" />
  //     </Tooltip>
  //   </>
  //   );
  // };

  const columns = [
    { field: "createdOn", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
    { field: "ssid", headerName: "Ssid", flex: 1 },
    { field: "roomNo", headerName: "Room No", flex: 1 },
    { field: "roomType", headerName: "Room Type", flex: 1 },
    { field: "cdsn", headerName: "CDSN", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{row?.cdsn.map((item, index) => <span>{index ? ', ' : ''}{item}</span>)}</p> },
    // {
    //   field: "actionCell",
    //   row: true,
    //   headerName: "Actions",
    //   flex: 0.5,
    //   renderCell: renderActionIcon,
    //   sortDirection: false,
    //   disableSortIcon: true,
    // },
  ];

  const roomListApi = () => {
    const apiPath = `get-rooms?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`;
    callAPI(apiPath, "POST", {roomNo:searchText}, { chainId: getChainIdLS() })
      .then((response) => {
        callAPI("/global-ssid", "GET", {}, { chainId: getChainIdLS() })
          .then((res) => {
            if (res.globalSsid !== "") {
              setValue("globalSsid", true);
              setValue('ssid', res?.globalSsid);
            }
          })
          .catch((err) => {
            console.warn(err.message);
          });
        setRoomList(response)
        setHideRoom(response?.displayRoomOnSTB)
        setTotalPageCount(response?.totalPages ? response?.totalPages : 1)
        setPaginationError("")
      })
      .catch((err) => console.warn(err.message));
  };

  useEffect(() => {
    roomListApi();
    cancelRoomHandler()
  }, [selectedPage, chainId, debouncedSearchText]);

  useEffect(() => {
    callAPI("/get-room-types", "GET", {}, { chainId: getChainIdLS() })
      .then((res) => {
        setRoomTypesMaster(res);
      })
      .catch((err) => {
        console.warn(err.message);
      });

      callGetCdsn()
      handleInputChange("")
  }, [chainId]);

  const callGetCdsn = () =>{
    callAPI("/get-cdsn", "GET", {}, { chainId: getChainIdLS() })
    .then((res) => {
      setCdsnsMaster(res);
    })
    .catch((err) => {
      console.warn(err.message);
    });
  }

  const popupCloseHandler = () => {
    setDeleteRoomPopUp(false);
  };

  useEffect(() => {
    if (editRoom) {
      getRoomListSidHandler();
      setEditRoom(false);
    }
    ScrollToTop();
  }, [editRoom, chainId]);

  const getRoomListSidHandler = () => {
    callAPI(`/get-rooms-id?roomId=${editRoomSid?.id}`, "GET", {}, { chainId: getChainIdLS() })
      .then(function (response) {
        const payload = {
          roomNo: response?.roomNo,
          roomType: response.roomType,
          cdsn: cdsnsMaster?.filter((item)=>response.cdsn?.includes(item?.cdsn)),
          ssid: response?.ssid,
          globalSsid: response?.globalSsid
        };
        reset(payload);
        callGetCdsn()
        setEditRoomUpdate(true);
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
      });
  }

  const resetLayoutHandler = () => {
    reset();
  }

  const cancelRoomHandler = () => {
    reset({
      roomNo: '',
      roomType: '',
      cdsn: [],
      ssid: '',
      globalSsid: false
    });
    setEditRoomUpdate(false);
    setEditRoomSid('');
    setEditRoom(false);
  }

  //Pagination Handle changer
  const onPageChange = (event, value) => {
    setInputPageValue(value)
    setPaginationError("")
    setSelectedPage(value);
  };

  // Function to handle data from child Excel popup
  const hotelRoomList = (data) => {
    roomListApi()
  };

  const hotelExcelDownload = () =>{
    setLoader(true)
    axios.get(`${process.env.REACT_APP_BASE_URL}/get-room-config`, { headers: { Authorization: `Bearer ${localStorage.getItem("jwt")}`, chainId: getChainIdLS() }, responseType: "blob", })
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response?.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            }));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", 'Room_Configuration_list.xlsx'); // Set file name
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            setLoader(false)
        })
        .catch(async (error) => {
            console.warn(error);
            setLoader(false)
        });
  }

  // Handle immediate input change for visual feedback
      const handleInputChange = (value) => {
          setSearchText(value); // Update immediately for UI responsiveness
          delayedSearch(value); // Trigger debounced validation
      };
  
      // Debounced function that updates the debounced state
      const delayedSearch = useCallback(
          debounce((value) => {
                  setDebouncedSearchText(value); // Only update debounced value when valid
          }, 600),
          []
      );

      const hideRoomNumbersHandler = (value) => {
        setPendingShowRoomValue(value);
        setShowRoomNumbersConfirmPopup(true);
      }

      const confirmShowRoomNumbersChange = () => {
        const value = pendingShowRoomValue;
        setShowRoomNumbersConfirmPopup(false);
        setPendingShowRoomValue(null);
        setHideRoom(value);
        callAPI(`/display-room?displayRoom=${value}`, "PUT", {}, { chainId: '1234r4' })
          .then((response) => {
            setCreateRoomSuccessMsg(response?.message);
          })
          .catch((err) => {
            console.warn(err.message);
            setHideRoom(!value);
          });
      }

      const cancelShowRoomNumbersChange = () => {
        setShowRoomNumbersConfirmPopup(false);
        setPendingShowRoomValue(null);
      }

  return (
    <div className='row config-hotel'>
      {loader && <div className="circular-progress"><CircularProgress /></div>}
      <div className='col-12 left-column'>
        <form autoComplete="off" onSubmit={handleSubmit(onSubmit)} className="hotel-list-form">
        <div className="flex-items-between">
              <strong>{editRoomUpdate ? 'Edit Room Details' : "Configuration New Room"}</strong>
              <div className="flex-item mb-2">
              <ConfigureNewRoomExcel hotelRoomList={hotelRoomList}/>
              <Tooltip title="Download Room List">
              <div onClick={hotelExcelDownload} className="cursor-pointer download-room-list">
                <FontAwesomeIcon
                  icon={faFileDownload}
                />
              </div>
              </Tooltip>
              </div>
            </div>
          <div className="row">
            <div className="form-group-hotel col-6">
              <div className="floating-label">
                <RiHotelBedFill className="new-hotel-icons" />
                <input
                  id="roomNo"
                  maxLength={10}
                  placeholder=""
                  {...register("roomNo", {
                    required: "Enter Room No",
                    pattern: {
                      value: /^[a-zA-Z0-9]+$/,
                      message: "Only alphanumeric characters are allowed",
                    },
                  })}
                />
                <label htmlFor="address">Enter Room No</label>
              </div>
              {errors.roomNo && (
                <small className="required">{errors.roomNo.message}</small>
              )}
            </div>
            <div className="col-6 form-group-hotel">
              <div className="floating-select-label">
                <Controller
                  name="roomType"
                  control={control}
                  rules={{
                    validate: (value) => (value !== undefined && value !== null && value !== '') || 'Please select room type',
                  }}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      className={`multiselectlist ${field?.value && field?.value?.length > 0 ? 'Mui-focused' : ''}`}
                      disablePortal
                      options={roomTypesMaster}
                      getOptionLabel={(option) => option}
                      onChange={(_, newValue) => {
                        field.onChange(newValue);
                      }}
                      value={field.value || ''}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder=""
                          variant="outlined"
                          label="Select Room Type"
                          InputLabelProps={{
                            shrink: false,
                          }}
                        />
                      )}
                    />
                  )}
                />
              </div>
              {errors.roomType && (
                <small className="required">{errors.roomType?.message}</small>
              )}
            </div>
            <div className="col-6 form-group-hotel">
              <div className="floating-select-label">
                <Controller
                  name="cdsn"
                  control={control}
                  rules={{
                    validate: value => Array.isArray(value) && value?.length > 0 || "Please select CDSN",
                  }}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      className={`multiselectlist ${field?.value && field?.value?.length > 0 ? 'Mui-focused' : ''}`}
                      disablePortal
                      limitTags={2}
                      multiple
                      noOptionsText="No CDSN Linked with the hotel"
                      options={cdsnsMaster}
                      getOptionLabel={(option) => option?.cdsn?.toString()}
                      onChange={(_, newValue) => {
                        field.onChange(newValue);
                      }}
                      value={field.value || []}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{
                            color: option.used ? "" : "green", // Change color based on condition
                            fontWeight: option.used ? "normal" : "bold", // Example: Bold for long text
                          }}
                        >
                          {option?.cdsn}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder=""
                          variant="outlined"
                          label="Select CDSN"
                          InputLabelProps={{
                            shrink: false,
                          }}
                        />
                      )}
                    />
                  )}
                />
              </div>
              {errors.cdsn && (
                <small className="required">{errors.cdsn?.message}</small>
              )}
            </div>
            <div className="form-group-hotel col-6">
              <div className="row">
                <div className="col-7">
                  <div className="floating-label">
                    {/* <RiHotelBedFill className="new-hotel-icons" /> */}
                    <input
                      id="ssid"
                      maxLength={30}
                      placeholder=""
                      {...register("ssid", {
                        required: "Enter SSID",
                      })}
                    />
                    <label htmlFor="address">Enter SSID</label>
                  </div>
                  {errors.ssid && (
                    <small className="required">{errors.ssid.message}</small>
                  )}
                </div>
                <div className="col-5 global-ssid ps-0">
                  <Checkbox
                    {...register("globalSsid")}
                    checked={watch("globalSsid")}
                    id={"globalSsid"}
                    size="small"
                    sx={{ minWidth: "9px", paddingRight:'4px' }}
                  />
                  <label>Use same SSID for all rooms</label>
                </div>
              </div>
            </div>
            <div className="col-12 text-end">
              <div>
                <button type="button" className="clear-btn me-2" onClick={cancelRoomHandler}>{editRoomUpdate ? "Cancel" : "Clear All"}</button>
                {editRoomUpdate && <>
                  <button type="button" className="clear-btn me-2" onClick={resetLayoutHandler}>Reset</button>
                </>}
                <button type="submit" className={`create-btn ${validPermissionClassName}`}>{editRoomUpdate ? "Update" : "Create"}</button>
              </div>
            </div>
          </div>
        </form>
        <div className="hotel-list">
          <div className="flex-items-between">
            <p><b>Hotel Rooms List</b></p>
            <div className="mb-3 flex-items-end">
            <FormControlLabel
              control={
                <Checkbox
                  type="checkbox"
                  name="active"
                  inputProps={{ "aria-label": "controlled" }}
                  value={hideRoom}
                  checked={hideRoom}
                  onChange={(e)=>hideRoomNumbersHandler(e.target.checked)}
                  // className={`${props?.row.enabled === false ? 'switchuser-inactive' : 'switchuser-active'} edit-icon-disable`}
                />
              }
              label="Show Room Numbers on STB"
            />
            <div className="form-group-hotel mb-0">
                <div className={`floating-label`}>
                    <input
                        id="searchRoomNumber"
                        maxLength={10}
                        placeholder=""
                        value={searchText}
                        className="form-control"
                        onChange={(e)=>
                          {
                            handleInputChange(e.target.value)
                            setInputPageValue(1)
                            setPaginationError("")
                            setSelectedPage(1);
                          }}
                    />
                    <label htmlFor="guestName">Search Room Number</label>
                </div>
                {/* {searchTextValidation && (
                    <small className="required">{searchTextValidation}</small>
                )} */}
            </div>
            </div>
          </div>
          <TableWrapper
            data={roomList?.roomResponse}
            columns={columns}
            module="room-config"
            noPagination={true}
          />
          <Custom_Paingation
            selectedPage={selectedPage}
            totalPageCount={totalPageCount}
            paginationError={paginationError}
            inputPageValue={inputPageValue}
            setSelectedPage={setSelectedPage}
            setPaginationError={setPaginationError}
            setInputPageValue={setInputPageValue}
            onPageChange={onPageChange}
          />
        </div>
      </div>
      <BasicModal
        popupOpen={deleteRoomPopUp}
        bodyMessage={<>
          <img src={deleteImg} alt="approve" className="w-40px" />
          <div className="delete-hotel mb-3">{isRoomDeletedRef.current?.isRoomDeletedModalData ?
            <div className="confirm-delete-hotel">
              <p>Do you really want to Delete Room No "<b>{isRoomDeletedRef.current?.isRoomDeletedModalData.row.roomNo}</b>" ?</p>
              <p className="warning"><IoMdWarning /> Warning</p>
              <p>Room No "{isRoomDeletedRef.current?.isRoomDeletedModalData.row.roomNo}" will be permanently deleted <br />
                Deleting the specified Room can't be undone.
              </p>
              <p className="mt-3">To confirm deletion, type "Delete Room No {isRoomDeletedRef.current?.isRoomDeletedModalData.row.roomNo}"</p>
              <div className="form-group-hotel mt-3">
                <div className="floating-label">
                  <input
                    id="deleteHotel"
                    placeholder=''
                    onChange={(e) => setConfirmDeleteRoom(e.target.value)}
                  />
                  <label htmlFor="address">Delete Room</label>
                </div>
                {(confirmDeleteRoom === "" && confirmValidate) ? (
                  <p className="text-start"><small className="required">Please Enter Delete Room No {isRoomDeletedRef.current?.isRoomDeletedModalData.row.roomNo}</small></p>
                ) : (confirmDeleteRoom !== `Delete Room No ${isRoomDeletedRef.current?.isRoomDeletedModalData.row.roomNo}` && confirmValidate) ? (
                  <p className="text-start"><small className="required">Please Enter Delete Room No {isRoomDeletedRef.current?.isRoomDeletedModalData.row.roomNo}</small></p>
                ) : ""
                }
              </div>
            </div> :
            isRoomDeletedRef.current?.userConformationModalData?.successMessage}</div>
        </>
        }
        footer={
          isRoomDeletedRef.current?.isRoomDeletedModalData ?
            {
              primaryButton: {
                buttonName: "Cancel",
                action: popupCloseHandler
              }
              ,
              secondaryButton: {
                buttonName: "Delete",
                action: deleteRoomHandler
              }
            } : {
              secondaryButton: {
                buttonName: "OK",
                action: popupCloseHandler
              }
            }
        }
      />

      <BasicModal
        popupOpen={createRoomSuccessMsg !== ""}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<p className="mt-2">{createRoomSuccessMsg}</p>}
        footer={
          {
            secondaryButton: {
              buttonName: "OK",
              action: () => { setCreateRoomSuccessMsg(''); setEditRoomUpdate(false); },
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
          }
        }
      />

      <BasicModal
        popupOpen={globalSsidMessagePopup}
        logo={"/Images/Rejected.png"}
        bodyMessage={<p className="mt-2">The Ssid will be used for all rooms, all available added SSid's (if any) will override. Are you sure you want to continue?</p>}
        footer={
          {
            secondaryButton: {
              buttonName: "OK",
              action: () => { setGlobalSsidMessagePopup(false); handleSubmit(onSubmit)() },
              buttonPrimaryCustomCss: 'cancel-btn_new'
            },
            primaryButton: {
              buttonName: "Cancel",
              action: () => {setGlobalSsidMessagePopup(false);}
            }
          }
        }
      />

      <BasicModal
        popupOpen={showRoomNumbersConfirmPopup}
        bodyMessage={
          <p className="mt-2">
            Are you sure you want to {pendingShowRoomValue ? 'show' : 'hide'} room numbers on STB?
          </p>
        }
        footer={{
          primaryButton: {
            buttonName: "Cancel",
            action: cancelShowRoomNumbersChange
          },
          secondaryButton: {
            buttonName: "Confirm",
            action: confirmShowRoomNumbersChange
          }
        }}
      />

    </div>
  )
}

export default ConfigurationNewRoom;